import styled from "styled-components";
import type { LTWHP } from "../types.js";

const StyledHighlight = styled.div`
  position: absolute;
`;

const Parts = styled.div`
  opacity: 1;
`;

const Part = styled.div`
  cursor: pointer;
  position: absolute;
  background: rgba(255, 226, 143, 1);
  transition: background 0.3s;
`;

interface Props {
  position: {
    boundingRect: LTWHP;
    rects: Array<LTWHP>;
  };
  onClick?: () => void;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
}

export function Highlight({
  position,
  onClick,
  onMouseOver,
  onMouseOut,
}: Props) {
  const { rects } = position;

  return (
    <StyledHighlight>
      <Parts className="Highlight__parts">
        {rects.map((rect, index) => (
          <Part
            onMouseOver={onMouseOver}
            onMouseOut={onMouseOut}
            onClick={onClick}
            key={index}
            style={rect}
            className="Highlight__part"
          />
        ))}
      </Parts>
    </StyledHighlight>
  );
}
